import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { ILot } from 'types/lots'
import { toast } from 'react-toastify'
import { translate } from 'hoc/Translate'

export const lotsApi = createApi({
  reducerPath: 'lots',
  tagTypes: ['Lots', 'SingleLot'],
  baseQuery,
  endpoints: (builder) => ({

    lots: builder.query<ILot[], void>({
      query: () => ({
        url: '/lots',
      }),
      providesTags: ['Lots'],
    }),

    lot: builder.query<ILot, IdParams>({
      query: ({ id }) => `/lots/${id}`,
      providesTags: ['SingleLot'],
    }),

    createLot: builder.mutation<ILot, Partial<ILot>>({
      query: (body) => ({
        url: '/lots',
        body,
        method: 'post',
      }),
    }),

    updateLot: builder.mutation<any, any>({
      // no edited
      query: (body) => ({
        url: `/lots`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['SingleLot'],
      onQueryStarted: () => {
        toast.success(translate('operation-success'))
      },
    }),
    
    deleteLot: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/lots/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useLotsQuery,
  useLotQuery,
  useCreateLotMutation,
  useUpdateLotMutation,
  useDeleteLotMutation,
} = lotsApi
